export default class Toggler {
    constructor(el) {
        el.addEventListener('click', this.adjustToggle, false);
    }
    adjustToggle(event) {
        if (!event.currentTarget)
            return;
        const clickElement = event.currentTarget;
        const id = clickElement.getAttribute('data-toggle-id');
        let target = (id === 'self') ? event.currentTarget : document.getElementById(id);
        // Bail if toggle doesn't exist
        if (!target)
            return;
        // Determine the class name for the target
        let toggleClass = clickElement.getAttribute('data-toggle-class');
        if (toggleClass === null)
            toggleClass = 'is-active';
        // Determine the class name for the toggler
        let togglerClass = clickElement.getAttribute('data-toggler-class');
        if (togglerClass === null)
            togglerClass = 'is-toggled';
        target.classList.toggle(toggleClass);
        clickElement.classList.toggle(togglerClass);
    }
}
